module.exports = __webpack_public_path__ + "static/img/badge-landing-rate-scheduled.fb60f30.svg";